import service from "@/api/service";
import { GetResponse } from "@/api/point-special/response";
import { GetRequest } from "@/api/point-special/request";

/**
 * スペシャルデー設定情報取得APIをコールします。
 *
 * @return GetResponse
 */
export async function get(getRequest: GetRequest) {
  const response = await service.post("/get-point-special", getRequest);
  return response.data as GetResponse;
}
